import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const TitleWithDescriptionSection = memo(({ theme, sectionId }) => {
  const TitleWithDescriptionSectionLayout = dynamic(() => import(/* webpackChunkName: 'TitleWithDescriptionSectionLayout' */ `../../../../../containers/home-page/views/sections/title-with-description/layouts/${theme.layout}`))

  return (
    <TitleWithDescriptionSectionLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

TitleWithDescriptionSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default TitleWithDescriptionSection
